<template>
    <v-card
        tile
        flat
        class="balanceCard"
        :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
    >
        <v-container>
            <v-row dense>
                <v-col cols="12">
                    <v-sheet
                        class="d-flex mb-0"
                        :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
                    >
                        <div class="title">
                            <v-icon dense color="#5F7692"
                                >mdi-bag-checked</v-icon
                            >
                            <span class="ml-2">Active Running Orders</span>
                            <p class="number mb-0 text--green">
                                {{
                                    managerActiveRunningOrdersDetails?.overallRunningOrders
                                }}
                                <strong>
                                    ({{
                                        managerActiveRunningOrdersDetails?.activeMargin?.toFixed(
                                            2
                                        )
                                    }}
                                    USD)</strong
                                >
                            </p>
                        </div>
                    </v-sheet>
                </v-col>
                <v-col cols="12">
                    <v-card-text
                        class="d-flex pl-3 pb-2 mt-4 pr-0 trade align-center"
                    >
                        <p class="equity">
                            <span class="mb-2 d-inline-block"
                                >Total Account:
                            </span>
                            {{
                                managerActiveRunningOrdersDetails?.totalAccount
                            }}
                            <br />
                            <span class="mb-2 d-inline-block"
                                >Total Running Order:
                            </span>
                            {{
                                managerActiveRunningOrdersDetails?.totalRunningOrders
                            }}
                            <br />
                            <span class="mb-2 d-inline-block"
                                >Total Active Lot:
                            </span>
                            {{ managerActiveRunningOrdersDetails?.activeLot }}
                        </p>
                        <v-spacer></v-spacer>
                        <p class="equity text-right">
                            <span class="mb-2 d-inline-block"
                                >Active Account:
                            </span>
                            {{
                                managerActiveRunningOrdersDetails?.activeAccounts
                            }}
                            <br />
                            <span class="mb-2 d-inline-block"
                                >Active Margin:
                            </span>
                            {{
                                managerActiveRunningOrdersDetails?.activeMargin?.toFixed(
                                    2
                                )
                            }}
                            <br />
                            <span class="mb-2 d-inline-block"
                                >Current Profit:
                            </span>
                            {{
                                managerActiveRunningOrdersDetails?.currentProfit?.toFixed(
                                    2
                                )
                            }}
                        </p>
                    </v-card-text>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { MAM__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState("mam", ["managerActiveRunningOrdersDetails"]),
    },
    methods: {
        ...mapActions("mam", [
            MAM__ACTIONS.MANAGERACTIVERUNNINGORDERDETAILS,
        ]),
    },
    async mounted() {
        await this[MAM__ACTIONS.MANAGERACTIVERUNNINGORDERDETAILS](
            this.$route.query.id
        );
    },
};
</script>
